module.exports = __webpack_public_path__ + "static/security1-c9e267dbf1db77c5ad1e43d803b33340.png";